import { Release } from "../../../../common/types/release/release";
import moment from "moment";

export const getReleaseDate = (release: Release, field?: 'previousReleaseDate' | 'releaseDate') => {
  const date = field ? release[field] : (
    release.releaseHistory === "previous"
      ? release.previousReleaseDate
      : release.releaseDate
  );

  return moment(date).format("MMM D YYYY");
};


export const serializeDateField = (date: string) => {
  return moment(date).toISOString();
};